<template>
  <roe-error-message :field="design.service_requirement_employee_deferrals">
    <v-select
      v-model="design.$model.service_requirement_employee_deferrals"
      :options="[
        { code: 0, label: 'No' },
        { code: 1, label: 'Yes, one requirement for all employees' },
        {
          code: 2,
          label: 'Yes, multiple requirements for different employees'
        }
      ]"
      :reduce="label => label.code"
      @input="onChange"
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
export default {
  name: "RoeServiceRequirementSelect",
  mixins: [ResetDesignAttributesMixin],
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    onChange() {
      this.resetAttributes(
        this.design,
        "service_requirement_employee_deferrals"
      );
      if (+this.design.$model.service_requirement_employer_match === 1) {
        this.design.$model.service_requirement_match_measurement_number = this.design.$model.service_requirement_measurement_number;
      }
      if (+this.design.$model.service_requirement_profit_sharing === 1) {
        this.design.$model.service_requirement_profit_sharing_measurement_number = this.design.$model.service_requirement_measurement_number;
      }
    }
  }
};
</script>
